var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteStoryIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.75 4.78105V3.98105C13.8298 3.27088 13.7554 2.55186 13.532 1.87305C13.3403 1.49674 13.0343 1.19079 12.658 0.999049C11.9792 0.775643 11.2602 0.701286 10.55 0.781049H8.95C8.23983 0.701286 7.52082 0.775643 6.842 0.999049C6.46569 1.19079 6.15974 1.49674 5.968 1.87305C5.74459 2.55186 5.67024 3.27088 5.75 3.98105V4.78105M7.75 10.281V15.2811M11.75 10.281V15.2811M0.75 4.78105H18.75M16.75 4.78105V15.9811C16.8697 17.0463 16.7581 18.1248 16.423 19.1431C16.1354 19.7075 15.6765 20.1664 15.112 20.4541C14.0938 20.7892 13.0153 20.9007 11.95 20.7811H7.55C6.48475 20.9007 5.40622 20.7892 4.388 20.4541C3.82354 20.1664 3.36462 19.7075 3.077 19.1431C2.74188 18.1248 2.63034 17.0463 2.75 15.9811V4.78105",
    stroke: "#FF2D1B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteStoryIcon);
export default __webpack_public_path__ + "static/media/delete_story_icon.1897b0b4f443cbe3848c885670f63fb0.svg";
export { ForwardRef as ReactComponent };